/* Header */
$.fn.Header = function() {
	let self = this

  self.el = {
    menuButton: self.find('.header__menu-btn'),
    menuContainer: self.next('.main-menu__container'),
    menuCloseButton: self.find('.header__close-btn'),
  }

  self.toggle = function() {
    if (self.el.menuButton.attr('aria-expanded') == 'true') {
      self.close()
    } else {
      self.open()
    }
  }

  self.open = function() {
    $('body').addClass('--menu-opened');
    self.el.menuButton.attr('aria-expanded', 'true')
    self.el.menuContainer.attr('aria-hidden', 'false')
  }

  self.close = function() {
    $('body').removeClass('--menu-opened');
    self.el.menuButton.attr('aria-expanded', 'false')
    self.el.menuContainer.attr('aria-hidden', 'true')
  }

  self.initialize_mobile = function() {
    /* Toggle on menu */
    self.el.menuContainer.find('.main-menu__item--parent').each(function() {
      $(this).find('.main-menu__link').on('click', function() {
        if ($.mlmi.mobile.isMobile) {
          $(this).parent().toggleClass('main-menu__item--opened')
          $(this).parent().find('.main-menu__sub-menu').slideToggle(250)
          return false;
        }
      })
    })
    $.mlmi.mobile.addCallbacks(function() {
      $('.main-menu__sub-menu').stop().css('display', '')
      $('.main-menu__item--opened').removeClass('main-menu__item--opened')
    }, function() {
      $('.main-menu__sub-menu').stop().css('display', '')
      $('.main-menu__item--opened').removeClass('main-menu__item--opened')
    })
  }

	return function() {
	  self.el.menuButton.on('click', self.toggle)
    self.el.menuCloseButton.on('click', self.close)
    self.initialize_mobile()
	  return self
	}()
}

export default {
	init() {
	  $('.header').Header()
	},
}
